import { render, staticRenderFns } from "./cartridge-air.vue?vue&type=template&id=8a1e7c2e"
import script from "./cartridge-air.vue?vue&type=script&lang=js"
export * from "./cartridge-air.vue?vue&type=script&lang=js"
import style0 from "./cartridge-air.vue?vue&type=style&index=0&id=8a1e7c2e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports